__turbopack_context__.v({
  "kitBox": "_gIoGW_kitBox",
  "kitBoxFrame": "_gIoGW_kitBoxFrame",
  "kitImageAir": "_gIoGW_kitImageAir",
  "kitPair": "_gIoGW_kitPair",
  "kitSamples": "_gIoGW_kitSamples",
  "kitSamplesFrame": "_gIoGW_kitSamplesFrame",
  "typeformContainer": "_gIoGW_typeformContainer",
  "typeformModal": "_gIoGW_typeformModal",
});
